/* eslint-disable @typescript-eslint/no-unsafe-return */
import { milesApiV2 } from '@src/libs/milesApiV2'
import {
    IBindReferralCodeResponse,
    IGenerateReferralCodeResponse,
    ILeaderboardDataResponse,
    IPointsBreakdownResponse,
} from '@src/types/point.api'

export const apiGetLeaderboard = async () => {
    const { data } = await milesApiV2.get<ILeaderboardDataResponse[]>(`/v1/leaderboard`)
    return data
}

export const apiGetBindMessageToSign = async (referralCode: string, walletAddress: string, timestamp: number) => {
    const { data } = await milesApiV2.post<string>(`/v1/referral/bind-message-to-sign`, {
        referral_code: referralCode,
        wallet: walletAddress,
        timestamp,
    })
    return data
}

export const apiGetBoundReferralCodeForWallet = async (walletAddress: string): Promise<string | null> => {
    const { data } = await milesApiV2.get<string | null>(`/v1/referral/bound-code/${walletAddress}`)
    return data
}

export const apiGetGeneratedReferralCodeForWallet = async (walletAddress: string): Promise<string | null> => {
    const { data } = await milesApiV2.get<string | null>(`/v1/referral/generated-code/${walletAddress}`)
    return data
}

export const apiGenerateReferralCode = async (walletAddress: string): Promise<IGenerateReferralCodeResponse> => {
    const { data } = await milesApiV2.post<IGenerateReferralCodeResponse>(`/v1/referral/generate-code/${walletAddress}`)
    return data
}

export const apiBindReferralCodeToWallet = async (
    referralCode: string,
    timestamp: number,
    walletAddress: string,
    signature: string
): Promise<IBindReferralCodeResponse> => {
    const { data } = await milesApiV2.post<IBindReferralCodeResponse>(`/v1/referral/bind-code`, {
        referral_code: referralCode,
        timestamp,
        wallet: walletAddress,
        signature,
    })
    return data
}

export const apiGetPointsBreakdown = async (address: string): Promise<IPointsBreakdownResponse> => {
    const { data } = await milesApiV2.get<IPointsBreakdownResponse>(`/v1/breakdown/${address}`)
    return data
}

export const apiGetCheckPoints = async (address: string): Promise<{ points: number }> => {
    const breakdown = await apiGetPointsBreakdown(address)

    const pointsTotal = Object.values(breakdown)
        .filter(value => typeof value === 'number')
        .reduce((sum, value) => sum + value, 0)

    return { points: pointsTotal }
}
